import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { HEDRICK_URL } from "@util/constant";

/**
 * Component to render Heidrick & Struggles Inc section on Partners page
 */
const HeidrickSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="heidrick-section-component">
      <AccordionV2
        testId="heidrick"
        className="border-l border-r py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Heidrick & Struggles Inc" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            Heidrick & Struggles International, Inc. (Nasdaq:HSII) is the
            premier provider of senior-level Executive Search, Culture Shaping
            and Leadership Consulting services. For 60 years, we have focused on
            quality service and built strong leadership teams through our
            relationships with clients and individuals worldwide. Today,
            Heidrick & Struggles leadership experts operate from principal
            business centers in North America, Latin America, Europe and Asia
            Pacific. In Singapore and across South East Asia, we work in every
            industry sector and across every functional area. We build our
            knowledge around sector and functional trends, and have demonstrated
            expertise in the Southeast Asian marketplace.
          </p>

          <p>
            For more information, visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={HEDRICK_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.heidrick.com
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default HeidrickSection;
